// extracted by mini-css-extract-plugin
export default {"GreyScale":"GreyScale_zqbPo"};